import {
  Alert,
  AlertDescription,
  Button,
  Card,
  CardContent,
  Input,
  Label,
  toast,
} from '@sitewise/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';


import { fetchMe } from '../../../api/auth.js';
import { updateProfile } from '../../../api/me.js';
import { ApiError } from '../../../lib/api-client.js';
import { useSyncStore } from '../../../stores/sync-store.js';

import { InstallAppCard } from './install-app.js';

export function ProfileSettingsPage() {
  const queryClient = useQueryClient();
  const meQuery = useQuery({ queryKey: ['me'], queryFn: fetchMe });
  const track = useSyncStore((s) => s.track);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (meQuery.data) {
      setName(meQuery.data.user.name);
      setEmail(meQuery.data.user.email);
    }
  }, [meQuery.data]);

  const mutation = useMutation({
    mutationFn: () => track(updateProfile({ name, email })),
    onSuccess: (data) => {
      queryClient.setQueryData(['me'], data);
      toast.success('Profile updated');
    },
  });

  return (
    <div className="space-y-6">
    <Card>
      <CardContent className="space-y-6 pt-6">
        <header>
          <h2 className="text-lg font-semibold">Profile</h2>
          <p className="text-sm text-fg-secondary">
            Your name and email are visible to other members of this organization.
          </p>
        </header>
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
          noValidate
        >
          <div className="space-y-1.5">
            <Label htmlFor="profile-name">Full name</Label>
            <Input
              id="profile-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="profile-email">Email</Label>
            <Input
              id="profile-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {mutation.error ? (
            <Alert variant="danger">
              <AlertDescription>
                {mutation.error instanceof ApiError
                  ? mutation.error.message
                  : 'Could not update profile.'}
              </AlertDescription>
            </Alert>
          ) : null}
          <div className="flex justify-end">
            <Button type="submit" disabled={mutation.isPending}>
              {mutation.isPending ? 'Saving…' : 'Save changes'}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
    <InstallAppCard />
    </div>
  );
}
